import Text from '../Text/Text';
import useFormattedCurrency from './useFormattedCurrency';

function Currency({ textType, value, negative = false }: CurrencyProps) {
  const formattedCurrency = useFormattedCurrency(value);

  return <Text type={textType}>{`${negative ? '-' : ''}${formattedCurrency}`}</Text>;
}

export default Currency;
